import type { IAppState } from 'shared/common/state';

/**
 * Главная РС всего проекта. Отключает весь функционал сразу.
 */
export const selectIsEtazhiBlackFridayEnabled = (state: IAppState) => {
  const isEnabled = !!state.config.get<boolean>('proApp.etazhiBlackFridayEnabled');

  return isEnabled;
};
